module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "span": 16
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.query.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyWord", $$v)
      },
      expression: "query.keyWord"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lists.length > 0),
      expression: "lists.length>0"
    }],
    staticClass: "prosList"
  }, [_c('el-row', {
    staticClass: "head"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("园所名称")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("园长姓名")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("园长电话")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("所属代理商")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("主联系人")])])], 1), _vm._v(" "), _vm._l((_vm.lists), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.chooseList(item)
        }
      }
    }, [_c('el-row', {
      staticClass: "linePadding"
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                        " + _vm._s(item.SchoolName) + "\n                    ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n                        " + _vm._s(item.PrincipalName) + "\n                    ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n                        " + _vm._s(item.PhoneNo) + "\n                    ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_vm._v("\n                        " + _vm._s(item.AgentCustomerName) + "\n                    ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_vm._v("\n                        " + _vm._s(item.C_name) + "\n                    ")])], 1)], 1)
  })], 2), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d50b740e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/schoolList/index.vue
// module id = 1567
// module chunks = 1